import BlockBigVideoItemArticle from '../../views_video/BlockBigVideoItemArticle'
import BlockArticles from '../../views_article/BlockArticles'
import BlockTwoLandscapeArticle from '../../views_article/BlockTwoLandscapeArticle'
import BlockThreeLandscapeArticle from '../../views_article/BlockThreeLandscapeArticle'
import BlockBigOneArticle from '../../views_article/BlockBigOneArticle'
import BlockEventsAndOnTourItems from '../../views_ontour/BlockEventsAndOnTourItems'
import BlockOnTourItems from '../../views_ontour/BlockOnTourItems'
import BlockAdTwo from '../../views_ads/BlockAdTwo'
import BlockBigArticle from '../../views_article/BlockBigArticle'
import BlockEventsAndAds from '../../views_article/BlockEventsAndAds'
import BlockFacebookAndArticle from '../../views_article/BlockFacebookAndArticle'
import BlockMostReadArticle from '../../views_article/BlockMostReadArticle'
import BlockOnTour from '../../views_ontour/BlockOnTour'
import WidgetRackPaper from '../../../../topics/Paper/widgets/WidgetRackPaper'
import BlockThreeArticle from '../../views_article/BlockThreeArticle'
import BlockVideoArticle from '../../views_article/BlockVideoArticle'
import BlockWeather from '../../views_weather/BlockWeather'
import WidgetInstagram from '../../../../topics/Social/widgets/WidgetInstagram'
import WidgetLeader from '../../../../topics/Article/widgets/WidgetLeader'
import BlockAdSingle from '../../views_ads/BlockAdSingle'
import Page from '../../../../topics/Search/components/SearchResult/components/AllCategories/components/Page'
import BlockSingleLandscapeArticle from '../../views_article/BlockSingleLandscapeArticle'
import WidgetDistrictNav from '../../../../topics/Home/widgets/WidgetDistrictNav'

const blockKeys = {
  big_video: (props) => ({
    component: BlockBigVideoItemArticle,
  }),
  articles: (props) => ({
    component: BlockArticles,
  }),
  two_landscape_article: (props) => ({
    component: BlockTwoLandscapeArticle,
  }),
  three_landscape_article: (props) => ({
    component: BlockThreeLandscapeArticle,
  }),
  big_one_article: (props) => ({
    component: BlockBigOneArticle,
  }),
  events_and_ontour_items: (props) => ({
    component: BlockEventsAndOnTourItems,
  }),
  ontour_items: (props) => ({
    component: BlockOnTourItems,
  }),
  ad_two: (props) => ({
    component: BlockAdTwo,
  }),
  big_article: (props) => ({
    component: BlockBigArticle,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
  }),
  events: (props) => ({
    component: BlockEventsAndAds,
    // margin: '0px 0px 0px 0px',
  }),
  facebook_article: (props) => ({
    component: BlockFacebookAndArticle,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
  }), //paddingTop paddingBottom
  mostread_article: (props) => ({
    component: BlockMostReadArticle,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
  }), //paddingTop paddingBottom
  ontour: (props) => ({
    component: BlockOnTour,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
    noGapEdge: true,
  }), //paddingBottom paddingTop
  rackpaper: (props) => ({
    component: WidgetRackPaper,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
    noGapEdge: true,
  }), //paddingTopMinus
  portrait_article: (props) => ({
    component: BlockThreeArticle,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
  }), //paddingTop paddingBottom
  three_article: (props) => ({
    component: BlockThreeArticle,
    margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
  }), //paddingTop paddingBottom //TODO similar Component
  special_box: (props) => ({
    component: BlockThreeArticle,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
    autoHide: true,
  }), //paddingTop paddingBottom
  video: (props) => ({
    component: BlockVideoArticle,
  }), //paddingTop paddingBottom
  weather: (props) => ({
    component: BlockWeather,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
    noGapEdge: true,
  }), //paddingBottomHalf minusPaddingTop
  instagram: (props) => ({
    component: WidgetInstagram,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
    noGapEdge: true,
  }),
  leader_headline: (props) => ({
    component: WidgetLeader,
    noGapEdge: true,
  }), //paddingTop paddingBottom
  pr: (props) => ({
    component: BlockThreeArticle,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
    pr: true,
  }),
  ad: (props) => ({
    component: BlockAdSingle,
    // margin: '0px 0px 0px 0px',
  }),
  landscape_article: (props) => ({
    component: BlockSingleLandscapeArticle,
    // margin: props.theme.sizes.gapVerticalHalf + ' 0px -' + props.theme.sizes.gapVerticalHalf + ' 0px',
  }), //paddingTop paddingBottom
  page_article: (props) => ({
    component: Page,
    margin: props.theme.sizes.gapVerticalHalf + ' 0px -' + props.theme.sizes.gapVerticalHalf + ' 0px',
  }), //paddingTop paddingBottom
  map: (props) => ({
    component: WidgetDistrictNav,
    // margin: props.theme.sizes.gapVertical + ' 0px 0px 0px',
    noGapEdge: true,
  }),
}

export default blockKeys
